var _a;
import { __assign } from "tslib";
import { BUTTONS } from 'wix-rich-content-editor-common';
import { GridIconSmall, MasonryIconSmall, MediaReplaceIcon, SettingsIcon, } from '../icons';
import { PluginToolbarButtons } from '../../../enums';
import { Modals } from '../modals';
var defaultButtons = [
    PluginToolbarButtons.BEST_FIT,
    PluginToolbarButtons.FULL_WIDTH,
    PluginToolbarButtons.LAYOUT_GRID,
    PluginToolbarButtons.LAYOUT_MASONRY,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.REPLACE,
    PluginToolbarButtons.DELETE,
];
var configurableButtons = (_a = {},
    _a[PluginToolbarButtons.BEST_FIT] = {
        keyName: 'sizeContent',
        type: BUTTONS.SIZE_CONTENT,
        mobile: false,
    },
    _a[PluginToolbarButtons.FULL_WIDTH] = {
        keyName: 'sizeFullWidth',
        type: BUTTONS.SIZE_FULL_WIDTH,
        mobile: false,
    },
    _a[PluginToolbarButtons.LAYOUT_GRID] = {
        keyName: 'layoutGrid',
        type: BUTTONS.TOGGLE,
        icon: GridIconSmall,
        mobile: true,
        onClick: function (store) {
            var data = store.get('componentData') || {};
            store.set('componentData', __assign(__assign({}, data), { styles: __assign(__assign({}, data.styles), { galleryLayout: 2 }) }));
        },
        tooltipTextKey: 'GalleryPlugin_Layout_Grid',
    },
    _a[PluginToolbarButtons.LAYOUT_MASONRY] = {
        keyName: 'layoutMasonry',
        type: BUTTONS.TOGGLE,
        icon: MasonryIconSmall,
        mobile: true,
        onClick: function (store) {
            var data = store.get('componentData') || {};
            store.set('componentData', __assign(__assign({}, data), { styles: __assign(__assign({}, data.styles), { galleryLayout: 1 }) }));
        },
        tooltipTextKey: 'GalleryPlugin_Layout_Masonry',
    },
    _a[PluginToolbarButtons.SEPARATOR] = {
        keyName: 'separator',
        type: BUTTONS.SEPARATOR,
        mobile: false,
    },
    _a[PluginToolbarButtons.REPLACE] = {
        keyName: 'add',
        type: 'file',
        icon: MediaReplaceIcon,
        mobile: false,
        multiple: true,
        tooltipTextKey: 'GalleryImageSettings_Replace_Label',
    },
    _a[PluginToolbarButtons.SETTINGS] = {
        keyName: 'advanced_settings',
        type: BUTTONS.EXTERNAL_MODAL,
        icon: SettingsIcon,
        modalName: Modals.GALLERY_SETTINGS,
        asPanel: true,
        mobile: false,
        tooltipTextKey: 'SettingsButton_Tooltip',
    },
    _a[PluginToolbarButtons.DELETE] = {
        keyName: 'delete',
        type: BUTTONS.DELETE,
        mobile: true,
    },
    _a);
export default (function (_a) {
    var pluginConfig = _a.pluginConfig, helpers = _a.helpers, t = _a.t;
    var buttons = pluginConfig.toolbar || defaultButtons;
    // If we only have one button toggle remove it
    var hasGrid = buttons.find(function (b) { return b === PluginToolbarButtons.LAYOUT_GRID; }) !== undefined;
    var hasMason = buttons.find(function (b) { return b === PluginToolbarButtons.LAYOUT_MASONRY; }) !== undefined;
    var hasFullWidth = buttons.find(function (b) { return b === PluginToolbarButtons.FULL_WIDTH; }) !== undefined;
    var hasBestFit = buttons.find(function (b) { return b === PluginToolbarButtons.BEST_FIT; }) !== undefined;
    var remove = {};
    if (!hasMason && hasGrid) {
        remove[PluginToolbarButtons.LAYOUT_GRID] = true;
    }
    if (hasMason && !hasGrid) {
        remove[PluginToolbarButtons.LAYOUT_MASONRY] = true;
    }
    if (!helpers.featureFlags['editor_experimental'] ||
        (hasFullWidth && !hasBestFit)) {
        remove[PluginToolbarButtons.FULL_WIDTH] = true;
        hasFullWidth = false;
    }
    if (!hasFullWidth && hasBestFit) {
        remove[PluginToolbarButtons.BEST_FIT] = true;
    }
    return buttons
        .filter(function (button) { return !!configurableButtons[button]; })
        .filter(function (button) { return (remove[button] ? false : true); })
        .filter(function (button, idx) {
        return idx === 0 && button === PluginToolbarButtons.SEPARATOR ? false : true;
    })
        .map(function (button) { return configurableButtons[button]; })
        .map(function (button) { return (__assign(__assign({}, button), { t: t })); });
});
//# sourceMappingURL=inline-buttons.js.map